import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserEventHistory } from "../thunk/userEventHistoryThunk";

export type UserEventHistoryType = {
    pk?: string;
    sk?: string;
    title: string;
    module: string;
    detail: string;
    create_at?: number;
};
type InitialValueType = {
    data: UserEventHistoryType[];
};
const initialState: InitialValueType = {
    data: [],
};
const userEventHistory = createSlice({
    name: "userEventHistory",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getUserEventHistory.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload,
            }
        })
        builder.addCase(getUserEventHistory.rejected, (state) => {
            return state;
        })
    },
});

export default userEventHistory.reducer;